"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TableFormWithFiles = exports.CardsForm = exports.TableForm = exports.TableCardsForm = void 0;

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _slicedToArray2 = require("babel-runtime/helpers/slicedToArray"),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _Stack = require("office-ui-fabric-react/lib/Stack"),
    _Button = require("office-ui-fabric-react/lib/Button"),
    _DynamicForm = require("../../DynamicForm"),
    _DynamicForm2 = _interopRequireDefault(_DynamicForm),
    _DynamicFormWithFiles = require("../DynamicFormWithFiles"),
    _DivTable = require("../DivTable"),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _Label = require("office-ui-fabric-react/lib/Label");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var inlineFormTable = {
  nolabels: !0,
  container: function c(a, b) {
    return _react2.default.createElement(_DivTable.Table, null, a, b);
  },
  row: function c(a, b) {
    return _react2.default.createElement(_DivTable.TableRow, {
      key: b
    }, a);
  },
  col: function c(a, b) {
    return _react2.default.createElement(_DivTable.TableCell, {
      key: b,
      style: {
        minWidth: 150
      }
    }, a);
  },
  headcol: function c(a, b) {
    return _react2.default.createElement(_DivTable.TableHead, {
      key: b
    }, _react2.default.createElement(_Label.Label, null, " ", a));
  }
},
    inlineFormCards = {
  container: function c(a, b) {
    return _react2.default.createElement("div", {
      style: {
        marginBottom: 12
      }
    }, b);
  },
  row: function c(a, b) {
    return _react2.default.createElement("div", {
      style: {
        display: "inline-block",
        border: "1px solid #eee",
        maxWidth: 300,
        padding: 12,
        paddingBotton: 20,
        margin: 5,
        marginBottom: 10
      },
      key: b
    }, a);
  },
  col: function c(a, b) {
    return _react2.default.createElement("div", {
      key: b
    }, a);
  },
  headcol: function c(a, b) {
    return _react2.default.createElement(_react2.default.Fragment, {
      key: b
    });
  }
},
    TableCardsForm = exports.TableCardsForm = _react2.default.memo(function (a) {
  var b = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      c = (0, _react.useState)(600 < b),
      d = (0, _slicedToArray3.default)(c, 2),
      e = d[0],
      f = d[1];
  return _react2.default.createElement(_react2.default.Fragment, null, (0, _get2.default)(a, "toggler", !0) && _react2.default.createElement(_Stack.Stack, {
    horizontal: !0,
    horizontalAlign: "end"
  }, _react2.default.createElement(_Button.DefaultButton, {
    toggle: !0,
    checked: e,
    onClick: function a() {
      return f(!e);
    },
    text: "Display as Table",
    iconProps: {
      iconName: e ? "Accept" : "Circle"
    }
  })), _react2.default.createElement(_DynamicForm2.default, (0, _extends3.default)({
    inlineForm: e ? inlineFormTable : inlineFormCards
  }, a)));
}),
    TableForm = exports.TableForm = function (a) {
  return _react2.default.createElement(_DynamicForm2.default, (0, _extends3.default)({
    inlineForm: inlineFormTable
  }, a));
},
    CardsForm = exports.CardsForm = function (a) {
  return _react2.default.createElement(_DynamicForm2.default, (0, _extends3.default)({
    inlineForm: inlineFormCards
  }, a));
},
    TableFormWithFiles = exports.TableFormWithFiles = function (a) {
  return _react2.default.createElement(_DynamicFormWithFiles.DynamicFormWithFiles, (0, _extends3.default)({
    inlineForm: inlineFormTable
  }, a));
};